import { Link } from "react-router-dom";
import { LEGAL_FULL, NAV, LEGENDTEAM_URL, CONTACT_EMAIL, LOGO_URL } from "@/lib/constants";
import { Flag, Mail } from "lucide-react";
import { openCookieSettings } from "@/components/CookieConsent";

const LOGO = LOGO_URL;

export default function Footer() {
  return (
    <footer className="bg-legend-ink text-slate-300 mt-16" data-testid="legal-footer">
      <div className="checkered h-2 w-full opacity-40" />
      <div className="max-w-7xl mx-auto px-4 py-12 grid gap-10 md:grid-cols-[1.4fr_1fr_1fr]">
        <div>
          <img src={LOGO} alt="Legend Magazine" className="h-24 bg-white rounded-sm p-3 mb-4" />
          <p className="text-sm leading-relaxed text-slate-400 max-w-md">
            Il magazine di chi vive il motorsport con passione. Rally, piloti, tecnica e retroscena dal cuore dell'Appennino romagnolo.
          </p>
          <a href={`mailto:${CONTACT_EMAIL}`} data-testid="footer-email" className="mt-4 inline-flex items-center gap-2 text-sm text-slate-300 hover:text-legend-red transition-colors">
            <Mail size={15} /> {CONTACT_EMAIL}
          </a>
        </div>
        <div>
          <h4 className="font-display font-bold uppercase text-white mb-3 tracking-wide">Sezioni</h4>
          <ul className="space-y-2 text-sm">
            {NAV.map((n) => (
              <li key={n.label}><Link to={n.to} className="hover:text-legend-red transition-colors">{n.label}</Link></li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="font-display font-bold uppercase text-white mb-3 tracking-wide">Legale</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-legend-red transition-colors">Privacy & Cookie Policy</Link></li>
            <li><button type="button" onClick={openCookieSettings} data-testid="footer-cookie-settings" className="hover:text-legend-red transition-colors">Impostazioni cookie</button></li>
            <li><Link to="/locandina" className="hover:text-legend-red transition-colors">Locandina Evento (PDF)</Link></li>
            <li><Link to="/abbonamenti" className="hover:text-legend-red transition-colors">Abbonamenti</Link></li>
            <li><Link to="/admin" className="hover:text-legend-red transition-colors">Area Redazione</Link></li>
            <li>
              <a href={LEGENDTEAM_URL} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 hover:text-legend-red transition-colors">
                <Flag size={12} /> LegendTeam.it
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 py-6">
          <p className="text-[11px] leading-relaxed text-slate-500" data-testid="footer-legal-text">{LEGAL_FULL}</p>
          <p className="text-[11px] text-slate-600 mt-3">© {new Date().getFullYear()} Legend Team S.r.l. Sportiva Dilettantistica — Tutti i diritti riservati.</p>
        </div>
      </div>
    </footer>
  );
}
